import { render, staticRenderFns } from "./ArchiveBudgets.vue?vue&type=template&id=6fe3eb0e&"
import script from "./ArchiveBudgets.vue?vue&type=script&lang=js&"
export * from "./ArchiveBudgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveBudgets.vue"
export default component.exports